let AppSettings = {
    mainColor: 'brand',
    backgroundColor: 'light-2',
    cardColor: 'light-1',
    currencyOptionFormater: {
        symbol: '€',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v' // %s is the symbol and %v is the value
    },
    currencyOptionFormaterNoDecimal: {
        symbol: '€',
        decimal: ',',
        thousand: '.',
        precision: 0,
        format: '%v' // %s is the symbol and %v is the value
    },
    toggleInsteadOfCheckbox: true,
    baremeAccessForAdmin: false,
    tva: 0.21,
    pdfRenderingOptions: {
        'pdf.margin.top': '30px',
        'pdf.scale': '0.8',
        waitFor: "#loaded"
    },
    defaultPollingTime: 30000,
    //NO TRAILING SLASH
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000',
    ownUrl: process.env.REACT_APP_OWN_URL || 'http://localhost:3007'
};
export default AppSettings;


// WEBPACK FOOTER //
// ./src/utils/appSettings.js